import { Student } from "models";

export class StudentSubjectMapping {
    academicYear: string;
    classroomId: number;
    id: number;
    studentProfile: Student;
    subject: any;
}
